import React from 'react';
import {
  AiChatStarterBubble,
  AiChatStarterBubblesContainer,
  AiConversationStarter,
} from '@/features/ai-agents/chat/starters';
import {
  PROMPT_USE_CASES,
  PromptUseCases,
} from '@/features/editor/widgets/ai-component/use-cases/prompt-use-cases';

export const getUseCasesStarters: AiConversationStarter = (
  sendMessage: (prompt: string, send: boolean) => void,
  attachFile: () => void,
  sketch: () => void,
): React.ReactNode => {
  const onClick = (useCase: PromptUseCases) => {
    if (useCase.openSketch) {
      sketch();
      return;
    }
    if (useCase.openImage) {
      attachFile();
    }
    if (useCase.prompt) {
      sendMessage(useCase.prompt, !!useCase.sendPrompt);
    }
  };

  return (
    <AiChatStarterBubblesContainer>
      {PROMPT_USE_CASES.map((useCase) => (
        <AiChatStarterBubble onClick={() => onClick(useCase)}>
          {useCase.title}
        </AiChatStarterBubble>
      ))}
    </AiChatStarterBubblesContainer>
  );
};
